export enum ACCESSIBILITY {
  NO,
  YES,
}
